export const getters = {
    systemTransporters: state => state.transporters,
    Transporter: state => state.systemTransporter
}
export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/transporters/getters.js